"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavigatorActions;
(function (NavigatorActions) {
    NavigatorActions["PageChanged"] = "PageChanged";
    NavigatorActions["MenuOpened"] = "MenuOpened";
    NavigatorActions["MenuClosed"] = "MenuClosed";
})(NavigatorActions || (NavigatorActions = {}));
exports.default = NavigatorActions;
